(function () {
  'use strict';

  angular
    .module('vehicleSettings')
    .config(function ($stateProvider) {
      return $stateProvider
        .state('root.vehicleSettings', {
          url: '/vehicle-settings?vfiltro=',
          views: {
            'content@': {
              templateUrl: 'configuracoes/vehicle-settings/vehicle-settings.tpl.html',
              controller: 'VehicleSettingsCtrl'
            }
          },
          data: {
            titulo: 'ce.configuracao.vehicleSettings.title',
            tituloDescricao: '',
            roles: [['VEHICLE_SETTINGS_VIEW']],
            hideTitulo: true
          }
        })
        .state('root.vehicleSettingsProfile', {
          url: '/vehicle-settings/profile/:profileId?vfiltro=',
          views: {
            'content@': {
              templateUrl: 'configuracoes/vehicle-settings/vehicle-settings-profile.tpl.html',
              controller: 'VehicleSettingsProfileCtrl'
            }
          },
          data: {
            titulo: 'ce.configuracao.vehicleSettings.title',
            tituloDescricao: '',
            roles: [['VEHICLE_SETTINGS_VIEW']],
            hideTitulo: true
          }
        });
    });
}());
